var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "old_password",
      "label": "原密码"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "password"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('old_password');
      }
    },
    model: {
      value: _vm.data.old_password,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "old_password", $$v);
      },
      expression: "data.old_password"
    }
  })], 1), _c('FormItem', {
    ref: "password",
    attrs: {
      "prop": "password",
      "label": "新密码"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "password"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('password');
      }
    },
    model: {
      value: _vm.data.password,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "password", $$v);
      },
      expression: "data.password"
    }
  })], 1), _c('FormItem', {
    ref: "password2",
    attrs: {
      "prop": "password2",
      "label": "再次确认密码"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "password"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('password2');
      }
    },
    model: {
      value: _vm.data.password2,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "password2", $$v);
      },
      expression: "data.password2"
    }
  })], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };